import { getImageUser, getImageUserNotFound } from '../../global-components/src/utils/auth';
import { UserStories } from '../../types';

interface Props {
  userStories: UserStories;
  hasUnseenStory: boolean;
  onClick: () => void;
}

const StoryItem: React.FC<Props> = ({ userStories, hasUnseenStory, onClick }) => {
  const { user } = userStories;

  return (
    <div
      className="text-center user-select-none"
      style={{ width: 70, cursor: 'pointer' }}
      onClick={onClick}
    >
      <div
        className={`story-avatar mb-1 ${
          hasUnseenStory ? 'story-avatar--unseen' : 'story-avatar--seen'
        }`}
      >
        <img
          src={getImageUser(user.img_account, undefined, user.name)}
          onError={e => (e.currentTarget.src = getImageUserNotFound(user.name))}
          className="rounded-circle"
          width={56}
          height={56}
          draggable={false}
        />
      </div>
      <small className="text-truncate d-block">
        {user.name}
      </small>
    </div>
  );
};

export default StoryItem;
